import { render, staticRenderFns } from "./ItemsWriteOffModal.vue?vue&type=template&id=48ef596b&"
import script from "./ItemsWriteOffModal.vue?vue&type=script&lang=js&"
export * from "./ItemsWriteOffModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports